import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import type {
	GridCustomCellProps,
	GridItemChangeEvent,
} from "@tql/ui-components-react/kendo/grid";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type {
	RoutingGuideEnumItem,
	RoutingGuideEnumsType,
} from "~/shared/schemas/routing-guide-schema.ts";

import type { RowUpdate, Rule } from "../../../modal/utils/types.ts";

type FieldSelectorCellProps = GridCustomCellProps & {
	handleRuleRowChange: (event: GridItemChangeEvent | RowUpdate<Rule>) => void;
	isReadOnly: boolean;
	routingGuideEnums?: RoutingGuideEnumsType;
	showActivationError?: boolean;
	cellTestId?: string;
};

export const FieldSelectorCell = ({
	handleRuleRowChange,
	isReadOnly,
	routingGuideEnums,
	showActivationError,
	...props
}: FieldSelectorCellProps) => {
	const dataItem = props.dataItem as Rule;
	const fieldSelectors = routingGuideEnums?.ifFieldSelectors ?? [];
	const selectedField =
		fieldSelectors.find((c) => c.name === dataItem.fieldSelector) ?? null;

	const hasError =
		showActivationError === true && !isReadOnly && !dataItem.fieldSelector;

	return (
		<GridTd data-testid={props.cellTestId} tdProps={props.tdProps}>
			<div
				style={
					hasError
						? {
								outline: "2px solid var(--kendo-color-error)",
								borderRadius: "2px",
							}
						: undefined
				}
			>
				<DropDownList
					data={fieldSelectors}
					dataItemKey={"value"}
					disabled={isReadOnly}
					onChange={(e: DropDownListChangeEvent) => {
						const selected = e.value as RoutingGuideEnumItem;
						handleRuleRowChange({
							dataItem,
							field: "fieldSelector" as keyof Rule,
							value: selected.name,
						});
					}}
					textField={"label"}
					value={selectedField}
				/>
			</div>
			{hasError ? (
				<span
					style={{
						color: "var(--kendo-color-error)",
						display: "block",
						fontSize: "11px",
						marginTop: "2px",
					}}
				>
					A value must be input in order to activate
				</span>
			) : null}
		</GridTd>
	);
};
